import React from 'react';
import { Box } from '@mui/material';
import { RankingPodiumOverlay } from '@pages/Portal/Competitions/Results/Overview/components/RankingPodiumOverlay';
import { PortalRankingEntry } from '@api/competitionsApi/interfaces';

type Props = {
  podium: PortalRankingEntry[];
  enrollmentCount?: number;
  aspectRatio?: number;
};

export const CompetitionActivityPodium: React.FC<Props> = ({
  podium,
  enrollmentCount = 0,
  aspectRatio = 700 / 300,
}): JSX.Element => {
  return (
    <Box
      sx={{
        position: 'relative',
        mb: 1,
        overflow: 'hidden',
        aspectRatio: `${aspectRatio}`,
        bgcolor: 'primary.main',
      }}
    >
      <RankingPodiumOverlay
        podium={podium}
        enrollmentCount={enrollmentCount}
        size="default"
      />
    </Box>
  );
};
